import { AxiosInstance } from 'axios';
import { PersonalReportsRepository } from '@/model/repository/manager/childcare-document/PersonalReportsRepository';

export const personalReportsRepositoryImpl =
  (Repository: AxiosInstance) =>
  (resource: string): PersonalReportsRepository => ({
    getBirthRecord(payload) {
      return Repository.get(`${resource}/birth-records/${payload.search_member_id}`);
    },
    getDigest(payload) {
      return Repository.get(`${resource}/digest`, { params: payload });
    },
    getMemberRecord(payload) {
      return Repository.get(`${resource}/member-record`, { params: payload });
    },
    getCustomRecord(payload) {
      return Repository.get(
        `${resource}/custom-records/${payload.search_member_id}/${payload.search_custom_plan_template_id}/${payload.search_display_date}`
      );
    },
    getDailyCustomRecordStatuses(payload) {
      return Repository.get(
        `${resource}/custom-records/${payload.member_id}/daily/${payload.custom_plan_template_id}/${payload.year}/${payload.month}/statuses`
      );
    },
    getWeeklyCustomRecordStatuses(payload) {
      return Repository.get(
        `${resource}/custom-records/${payload.member_id}/weekly/${payload.custom_plan_template_id}/${payload.fiscal_year}/statuses`
      );
    },
    getMonthlyCustomRecordStatuses(payload) {
      return Repository.get(
        `${resource}/custom-records/${payload.member_id}/monthly/${payload.custom_plan_template_id}/${payload.fiscal_year}/statuses`
      );
    },
    getCustomIrregularRecords(payload) {
      return Repository.get(
        `${resource}/custom-irregular-records/${payload.search_member_id}/${payload.search_custom_plan_template_id}`,
        { params: { listpage: payload.listpage } }
      );
    },
    getCustomIrregularRecordDetail(payload) {
      return Repository.get(
        `${resource}/custom-irregular-records/${payload.member_id}/${payload.custom_plan_template_id}/${payload.topic_id}`
      );
    },
  });
